<template>
  <span class="order-status">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">    
          <div v-bind="attrs" v-on="on">
                <bx-tag v-if="status == 0" color="yellow">{{$t("lang.common.pending")}}</bx-tag>    
                <bx-tag v-if="status == 1" color="blue">{{$t("lang.common.in_progress")}}</bx-tag>
                <bx-tag v-if="status == 2" color="green">{{$t("lang.common.completed")}}</bx-tag>

        </div>
      </template>
      <span>{{ statusTooltip }}</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: "bx-order-nice-status",
  props: {
    status: {
      type: [Number, String],
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusTooltip: {
      get() {
        let text;
        if (this.status === 1) {
          text = this.$t("lang.order_status.status_1");
        } else if (this.status === 2) {
          text = this.$t("lang.order_status.status_2");
        } else if (this.status === 3) {
          text = this.$t("lang.order_status.status_3");
        }
        return text;
      }
    }
  }
};
</script>
